module.exports = __webpack_public_path__ + "static/media/car-top-right-black.ac4af68d.svg";